import { service } from "../utils/service";
import { localPath } from "./api.js";

// 促销活动单添加 (门店端-促销活动单-促销活动单添加)
export function addDocPromotion(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/add",
    method: "post",
    data: params
  });
}
// 疗程单作废 (门店端-疗程单-疗程单作废)
export function cancelDocPromotion(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/cancel",
    method: "post",
    data: params
  });
}
// 分页查询 门店端-促销活动单-分页查询促销活动单
export function docPromotionPage(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/page",
    method: "post",
    data: params
  });
}
export function docPromotionPageNew(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/pageNew",
    method: "post",
    data: params
  });
}
// 门店员工业绩提成统计列表 门店端-首页-门店员工业绩提成统计列表
export function statisticStaffDayList(params) {
  return service({
    url: "/api" + "/demay/ssm/storeStatistic/staffDayList",
    method: "post",
    data: params
  });
}
// 促销活动单业务员修改 (门店端-促销活动单-促销活动单业务员修改)
export function docPromotionEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/updateStaff",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/home.js